import { alpha } from "@mui/material";

const disabledMuiColorCode = alpha("#000", 0.3);
const activeMuiColorCode = alpha("#000", 0.9);

export const disabledMuiStyle = (disabled: boolean | undefined) => {
  return {
    color: disabled ? disabledMuiColorCode : activeMuiColorCode,
  };
};
